import React, { useState } from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { NON_CONTRACT } from "../../util/constants";

const BidAwardNameCell = (props) => {
  const [awardedNameMenuAnchor, setAwardedNameMenuAnchor] = useState(null);
  return (
    <div>
      <Typography
        style={{ cursor: "pointer" }}
        fontSize="14px"
        onClick={(event) => {
          setAwardedNameMenuAnchor(event.currentTarget);
        }}
        id={props.row.awardedEid}
      >
        <u>
          {props.row.awardedLastName}, {props.row.awardedShortName}
        </u>
      </Typography>

      <Menu
        data-testid="bidAward-detail-menu"
        anchorEl={awardedNameMenuAnchor}
        open={!!awardedNameMenuAnchor && awardedNameMenuAnchor.id === props.row.awardedEid}
        onClose={(event) => {
          setAwardedNameMenuAnchor(null);
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => props.handleAwardedNameBidChoicesClick(props.row)}>Bid Choices</MenuItem>
        {props.bidContractType !== NON_CONTRACT && (
          <MenuItem onClick={() => props.handleAwardedNamePermanentBidClick(props.row)}>Permanent Bid</MenuItem>
        )}
      </Menu>
    </div>
  );
};

BidAwardNameCell.propTypes = {
  row: PropTypes.object.isRequired,
  handleAwardedNameBidChoicesClick: PropTypes.func.isRequired,
  handleAwardedNamePermanentBidClick: PropTypes.func.isRequired,
  bidContractType: PropTypes.string.isRequired,
};

export default BidAwardNameCell;
